import {
  Collapse,
  Icons,
  List,
  ShowButton,
  Space,
  Table,
  TableColumnGroupType,
  TableColumnType,
  TextField,
  // useModalForm,
  useTable,
} from '@pankod/refine-antd'
import React from 'react'
import {
  GetListResponse,
  HttpError,
  IResourceComponentsProps,
  LogicalFilter,
  // useDelete,
} from '@pankod/refine-core'
import Head from 'next/head'

import { LPTKResponse } from './types'
import Filter, { TFilterForm } from '@components/ContentFilter'
import { HeaderTitle } from '@components/HeaderTableTitle'
// import { ModalForm } from './blocks/ModalForm'
// import { showErrorNotification } from '@resources/angkatan-ppg-management/utils'

const LPTK_RESOURCE = 'lptk'

export const LPTKList: React.FC<
  IResourceComponentsProps<GetListResponse<LPTKResponse>>
> = ({ options }) => {
  const { tableProps, filters, searchFormProps } = useTable<
    LPTKResponse,
    HttpError,
    TFilterForm<{ name?: string }>
  >({
    resource: LPTK_RESOURCE,
    dataProviderName: 'lms',
    syncWithLocation: true,
    defaultSetFilterBehavior: 'replace',
    onSearch: ({ name }) => {
      const trimmedName = name?.trim()

      return trimmedName
        ? [{ field: 'name', operator: 'eq', value: trimmedName }]
        : []
    },
  })

  const currentFilters = (filters as LogicalFilter[] | undefined) || []
  const hasNameFilter = currentFilters.some(
    ({ field, value }) =>
      field === 'name' && typeof value === 'string' && Boolean(value.trim()),
  )

  // const { mutateAsync: doDelete, isLoading } = useDelete()

  // const {
  //   modalProps: createModalProps,
  //   formProps: createFormProps,
  //   show: createShow,
  //   close: createClose,
  // } = useModalForm({
  //   action: 'create',
  //   resource: LPTK_RESOURCE,
  //   dataProviderName: 'lms',
  //   warnWhenUnsavedChanges: true,
  //   redirect: false,
  //   autoResetForm: true,
  //   autoSubmitClose: true,
  //   invalidates: ['list'],
  //   successNotification: {
  //     message: 'LPTK successfully created',
  //     type: 'success',
  //     description: 'Successful',
  //   },
  //   errorNotification: (error) =>
  //     showErrorNotification(error, 'There was a problem when creating LPTK'),
  // })

  const columns: (
    | TableColumnType<LPTKResponse>
    | TableColumnGroupType<LPTKResponse>
  )[] = [
    {
      title: <HeaderTitle align="left" title="ID" />,
      key: 'id',
      dataIndex: 'id',
    },
    {
      title: <HeaderTitle align="left" title="Nama LPTK" />,
      key: 'name',
      dataIndex: 'name',
      width: '75%',
    },
    {
      key: 'action',
      width: '20%',
      render: (_, record) => (
        <Space>
          <ShowButton recordItemId={record.id}>Lihat</ShowButton>
          {/* <PopDeleteConfirm
            title="Apakah Anda yakin ingin menghapus LPTK ini?"
            onConfirm={() => {
              return doDelete({
                id: record.id,
                resource: 'lptk',
                dataProviderName: 'lms',
                invalidates: ['list'],
                successNotification: {
                  message: 'LPTK successfuly removed',
                  type: 'success',
                  description: 'Successful',
                },
                errorNotification: (error) =>
                  showErrorNotification(
                    error,
                    'There was an error when removing LPTK'
                  ),
              })
            }}
            children={
              <Button danger icon={<Icons.DeleteOutlined />}>
                Hapus
              </Button>
            }
            okText="Hapus"
            cancelText="Kembali"
            okButtonProps={{ danger: true, loading: isLoading }}
          /> */}
        </Space>
      ),
    },
  ]

  return (
    <List
      title="Daftar LPTK"
      // headerButtons={() => (
      //   // <Button
      //   //   icon={<Icons.PlusOutlined />}
      //   //   type="primary"
      //   //   onClick={() => createShow()}
      //   // >
      //   //   Buat LPTK
      //   // </Button>
      //   <></>
      // )}
    >
      <Head>
        <title>LMS Admin | {options?.label}</title>
      </Head>

      <Collapse className="!mb-4" bordered={false}>
        <Collapse.Panel
          header={
            <>
              {hasNameFilter ? (
                <Icons.FilterFilled
                  className="mr-1"
                  style={{ color: '#08c' }}
                />
              ) : (
                <Icons.FilterOutlined className="mr-1" />
              )}
              <TextField value="Filter LPTK" strong={hasNameFilter} />
            </>
          }
          key="filter-lptk"
        >
          <Filter
            size="small"
            formProps={searchFormProps}
            filters={currentFilters}
            showClearAll
            items={[
              {
                label: 'Nama LPTK',
                name: 'name',
                placeholder: 'Cari berdasarkan nama LPTK',
              },
            ]}
          />
        </Collapse.Panel>
      </Collapse>

      <Table<LPTKResponse> {...tableProps} columns={columns} rowKey="id" />
    </List>
  )
}
